module.exports = __webpack_public_path__ + "img/gnu_gallery6.c80101b3.jpg";